import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const projectSlice = createSlice({
    name: 'project',
    initialState: {
        projects:[],
        selectedProjectId:0,
        selectedProjectPlans: null,
    },
    reducers: {
        setProjects: (state, action) => {
            state.projects = action.payload;
        },
        setSelectedProjectId: (state, action) => {
            state.selectedProjectId = action.payload;
        },
        setSelectedProjectPlans: (state, action) => {
            state.selectedProjectPlans = action.payload;
        },
    },
});


const { reducer, actions } = projectSlice;


export const { setProjects, setSelectedProjectId, setSelectedProjectPlans } = actions;


export const getProjects = (state) => {
    return state.project.projects || [];
};

export const getSelectedProjectId = (state) => {
    return state.project.selectedProjectId || 0;
};

export const getSelectedProjectPlans = (state) => {
    return state.project.selectedProjectPlans;
};


export default reducer;
